import { translate } from '../../../../utils/locale';
import { fetchSubscriptionSizes } from '../../../../api/subscriptionSizesAPI';
import { updateErrorMessage, setSubscriptionSizes, updateSizesLoading } from '../slice';

const toCamelCase = (value: string) =>
	value
		.split(' ')
		.map((word, i) =>
			i === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
		)
		.join('');

const displaySubscriptionSize = (
	minimumStudentNumber: number,
	maximumStudentNumber: number | null
) => {
	if (minimumStudentNumber === 0 && maximumStudentNumber !== null)
		return `< ${maximumStudentNumber + 1}`;
	return (
		minimumStudentNumber + (maximumStudentNumber !== null ? ' - ' + maximumStudentNumber : '+')
	);
};

export const getSubscriptionSizeThunk = (): AppThunk => async (dispatch) => {
	try {
		dispatch(updateSizesLoading(true));
		const response = await fetchSubscriptionSizes();
		if (response.HasError) {
			dispatch(
				updateErrorMessage(
					translate('manageAccount.subscriptions.errors.FAILED_TO_FETCH_DATA') as string
				)
			);
			dispatch(setSubscriptionSizes([]));
		} else {
			const subscriptionSizes: ManageAccount.SizeOption[] = response.ResponseObject.map((size) => ({
				value: toCamelCase(size.DisplayName),
				label: displaySubscriptionSize(size.MinimumStudentNumber, size.MaximumStudentNumber),
				id: size.Id,
			}));

			dispatch(setSubscriptionSizes(subscriptionSizes));
		}
	} catch {
		dispatch(
			updateErrorMessage(
				translate('manageAccount.subscriptions.errors.FAILED_TO_FETCH_DATA') as string
			)
		);
		dispatch(setSubscriptionSizes([]));
	}
};
